var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid p-0"},[_c('div',{staticClass:"card shadow-0 border-0",staticStyle:{"background-color":"inherit"}},[_c('div',{staticClass:"card-body skin light-bg text-center card-img-top"},[_c('h6',{staticClass:"font-weight-semibold mb-0 font-weight-bolder"},[_vm._v(_vm._s(_vm.name))])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-79c47b81","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/qrcode/view-qrcode.vue
// module id = 1782
// module chunks = 0